import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { distinctUntilChanged } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { Nav, NavData } from '../../_nav';

@Component({
  templateUrl: '404.component.html'
})
export class P404Component implements OnInit {
  public items;
  public newItems: NavData[] = [];

  constructor(private router: Router, private authService: AuthService) {
  }

  ngOnInit() {
    this.items = new Nav()
    this.authService.getAC_controls.subscribe(res => {
      let controls = res
      console.log(controls)
      controls.urls.forEach(url => {
        for (let item in this.items) {
          for (let nav in this.items[item]) {
            if (this.items[item][nav]['url'] == url) {
              this.newItems.push(this.items[item][nav])
            } else null
          }
        }
      })
    })
    // this.authService.ac_controls.urls.forEach(url => {
    //   for (let item in this.items) {
    //     for (let nav in this.items[item]) {
    //       if (this.items[item][nav]['url'] == url) {
    //         this.newItems.push(this.items[item][nav])
    //       } else null
    //     }
    //   }
    // })
  }

  navigateTo(url) {
    this.router.navigate([`home/${url}`]);
    this.newItems = [];
  }


  logout() {
    this.authService.logout();
  }
}
